import React, { useContext } from 'react';
import { isBoleto } from '../../models/Account';
import { FullReportEntry } from "../../models/FullReportEntry";
import { AccountContext } from '../AccountContext';
import { FilterAction } from "./FilterAction";

export type CategoryFilter = Record<string, (a:FullReportEntry) => boolean>

const categoryFilters:Record<string, CategoryFilter> = {
    "Meio de Pagamento": {
        "Cartão": (a) => !isBoleto(a),
        "Boleto": (a) => isBoleto(a)
    },
    "Orçamento": {
        "8k ou superior": (a) => a.budget >= 8000,
        "Abaixo de 8k": (a) => a.budget < 8000
    },

    "Meta de Leads": {
        "Até 200": (a) => a.goal <= 200,
        "201 a 400": (a) => a.goal > 200 &&  a.goal <= 400,
        "401 a 800": (a) => a.goal > 400 &&  a.goal <= 800,
        "801+": (a) => a.goal > 800
    }
}

export function buildCategoryFilter(categoryFilters: Record<string, CategoryFilter>, type:FilterAction = FilterAction.setCategory, label = "Categoria de contas..."):[CategoryFilter, ({selected}:{selected: string})=>JSX.Element]{
    const catFilters :CategoryFilter = {}
    Object.entries(categoryFilters).forEach(([k, v]) => {
        Object.entries(v).forEach(([k, fn]) => {
            catFilters[k] = fn;
        })
    })
    
    function CategoryFilterMenu({selected}:{selected: string}){
        const {dispatch} = useContext(AccountContext);
    
        return <div className="menu my-2">
            <select className="form-select" value={selected || ""} onChange={(e) => dispatch({type, payload: e.target.value})}>
                <option value={""}>{label}</option>
                {Object.entries(categoryFilters).map(([k, v]) => 
                   <optgroup label={k}>
                         {Object.keys(v).map(o => <option value={o}>{o}</option>)}
                   </optgroup>) }
            </select>
        </div>
    }

    return [catFilters, CategoryFilterMenu];
}

export const [catFilters, CategoryFilterMenu] = buildCategoryFilter(categoryFilters);